/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AskIndexRequest = {
  /**
   * The name of the index to ask a question to
   */
  indexName: string;
  askIndexRequest: components.AskIndexRequest;
};

/** @internal */
export const AskIndexRequest$inboundSchema: z.ZodType<
  AskIndexRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  index_name: z.string(),
  AskIndexRequest: components.AskIndexRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "index_name": "indexName",
    "AskIndexRequest": "askIndexRequest",
  });
});

/** @internal */
export type AskIndexRequest$Outbound = {
  index_name: string;
  AskIndexRequest: components.AskIndexRequest$Outbound;
};

/** @internal */
export const AskIndexRequest$outboundSchema: z.ZodType<
  AskIndexRequest$Outbound,
  z.ZodTypeDef,
  AskIndexRequest
> = z.object({
  indexName: z.string(),
  askIndexRequest: components.AskIndexRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    indexName: "index_name",
    askIndexRequest: "AskIndexRequest",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AskIndexRequest$ {
  /** @deprecated use `AskIndexRequest$inboundSchema` instead. */
  export const inboundSchema = AskIndexRequest$inboundSchema;
  /** @deprecated use `AskIndexRequest$outboundSchema` instead. */
  export const outboundSchema = AskIndexRequest$outboundSchema;
  /** @deprecated use `AskIndexRequest$Outbound` instead. */
  export type Outbound = AskIndexRequest$Outbound;
}

export function askIndexRequestToJSON(
  askIndexRequest: AskIndexRequest,
): string {
  return JSON.stringify(AskIndexRequest$outboundSchema.parse(askIndexRequest));
}

export function askIndexRequestFromJSON(
  jsonString: string,
): SafeParseResult<AskIndexRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AskIndexRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AskIndexRequest' from JSON`,
  );
}
